import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PoPageImpl() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    });

    return (
       <div>PoPageImpl</div>
    )

}